import { useCallback, useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { tl } from "@/lib/subscription";

const EMPTY = { name: "", duration_days: 30, price_tl: "", description: "", is_active: false, order: 9 };

const PackageRow = ({ p, onSaved }) => {
  const [f, setF] = useState({ ...p, price_tl: p.price_tl ?? "" });
  const up = (k, num) => (e) => setF({ ...f, [k]: num ? e.target.value : e.target.value });
  const save = async () => {
    const body = { name: f.name, duration_days: Number(f.duration_days), price_tl: f.price_tl === "" ? null : Number(f.price_tl), description: f.description, is_active: f.is_active, order: Number(f.order) || 0 };
    try { p.id ? await api.put(`/admin/sub-packages/${p.id}`, body) : await api.post("/admin/sub-packages", body); toast.success("Paket kaydedildi"); onSaved(); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };
  const tid = p.id || "new";
  return (
    <div className="rounded-2xl border p-3 grid gap-2 sm:grid-cols-[1.2fr_90px_120px_70px] items-end" data-testid={`sub-pkg-${tid}`}>
      <div><Label className="text-xs">Paket adı</Label><Input className="h-8 mt-1" value={f.name} maxLength={60} onChange={up("name")} data-testid={`sub-pkg-name-${tid}`} /></div>
      <div><Label className="text-xs">Süre (gün)</Label><Input type="number" className="h-8 mt-1" value={f.duration_days} onChange={up("duration_days", 1)} data-testid={`sub-pkg-days-${tid}`} /></div>
      <div><Label className="text-xs">Fiyat (₺, boş = yok)</Label><Input type="number" min={0} step="0.01" className="h-8 mt-1" value={f.price_tl} onChange={up("price_tl", 1)} data-testid={`sub-pkg-price-${tid}`} /></div>
      <div><Label className="text-xs">Sıra</Label><Input type="number" className="h-8 mt-1" value={f.order} onChange={up("order", 1)} data-testid={`sub-pkg-order-${tid}`} /></div>
      <div className="sm:col-span-4"><Label className="text-xs">Açıklama</Label><Input className="h-8 mt-1" value={f.description} maxLength={300} onChange={up("description")} data-testid={`sub-pkg-desc-${tid}`} /></div>
      <div className="sm:col-span-4 flex items-center justify-between gap-2 flex-wrap">
        <label className="flex items-center gap-2 text-xs"><Switch checked={f.is_active} onCheckedChange={(v) => setF({ ...f, is_active: v })} data-testid={`sub-pkg-active-${tid}`} />{f.is_active ? "Satışta" : "Yayın dışı"}</label>
        <span className="text-xs text-muted-foreground">Görünen: {f.name || "—"} · {tl(f.price_tl === "" ? null : f.price_tl)}</span>
        <Button size="sm" onClick={save} data-testid={`sub-pkg-save-${tid}`}>Kaydet</Button>
      </div>
    </div>
  );
};

export const SubPackages = () => {
  const [rows, setRows] = useState(null);
  const [adding, setAdding] = useState(false);
  const load = useCallback(() => { api.get("/admin/sub-packages").then(({ data }) => { setRows(data); setAdding(false); }).catch(() => setRows([])); }, []);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="space-y-3" data-testid="sub-admin-packages">
      <p className="text-xs text-muted-foreground">Fiyatı boş veya “Yayın dışı” paketler işletmelere gösterilmez. Fiyat değişikliği yalnızca yeni ödeme bildirimlerini etkiler; bekleyen bildirimler bildirim anındaki tutarla kalır. Paketler silinmez, yayın dışı bırakılır.</p>
      {rows?.map((p) => <PackageRow key={p.id + p.updated_at} p={p} onSaved={load} />)}
      {adding ? <PackageRow p={EMPTY} onSaved={load} /> : <Button variant="outline" onClick={() => setAdding(true)} data-testid="sub-pkg-add"><Plus className="w-4 h-4 mr-1" />Yeni paket</Button>}
    </div>
  );
};
